import React, { useEffect, useRef, useState } from "react";
import {
  ScrollView,
  SectionList,
  StyleSheet,
  Text,
  View,
  Pressable,
} from "react-native";

import { UserSchema } from "../../realm/contactSchema";
import { CSearchInput } from "../../components/CSearchInput";
import { ListEmpty } from "../../components/ListEmpty";
import { getAvatarByItem, userListByLetter } from "../../utils/utils";
import { getUserName, useNavigationToChatView2 } from "./chat-helper";
import {
  color_333333,
  color_666666,
  color_E9E9E9,
  color_EEF3FA,
  color_main,
  white,
} from "../../assets/style/colors";
import * as ImSdk from "../../../imsdk/api/index";
import { createChat } from "../Contact/CreateChat";
import { User } from "../../../imsdk/db/t_user";
import { CListItem, LeftView, isSystemAcc } from "./CListItem";
import {
  Str_Cancel,
  Str_Confirm,
  Str_CreateNewSession,
  Str_Search,
} from "../../language/string_res";
import { MainNavProps } from "../navigation/main/MainParamList";
import getItemLayout from "../GetItemLayout";
import { Letter } from "../../components/Letter";
import { useStore } from "../../store/UserStore";
import { ScreenCancelModal, ScreenModal } from "../../components/ScreenModal";

type SectionProps = {
  title: string;
  data: any[];
};

export function ForwardNewChat({
  navigation,
  route,
}: MainNavProps<"ForwardNewChat">) {
  const [search, setSearch] = useState("");
  const [bappkey, setBAppkey] = useState(""); // 限制B公司的Appkey
  const [selectUids, setSelectUids] = useState<Set<number>>(new Set<number>());
  const [selectContact, setSelectContact] = useState<User[]>([]);
  const [section, setSection] = useState<SectionProps[]>([]);
  const [isLoading, setIsLoading] = useState(false); // 加载状态
  const sectionRef = useRef<SectionList<any, SectionProps>>(null);
  const toChatView = useNavigationToChatView2();
  const allUsers = useRef<any[]>();
  const { from, msg } = route.params;
  const im = ImSdk.getInstance();
  const uid = im.CurrentUid();
  const { state } = useStore();

  useEffect(() => {
    setSelectUids(new Set());
    setBAppkey("");
    setSearch("");
    setSelectContact([]);
    // setAllUsers([]);
    const c = state?.contactList ?? [];
    const b = state?.contactBlackList ?? [];
    const result = new Set<User>();
    c.forEach((value) => {
      const b1 = value.status === "deleted";
      const b2 = b.some((item) => item.uid === value.uid);
      const b3 = isSystemAcc(value.uid);
      const b4 = value.uid === uid;
      console.log("value", value.name, value.uid, b1, b2, b3, b4);
      if (!(b1 || b2 || b3 || b4)) {
        result.add(value);
      }
    });
    const users = Array.from(result);
    allUsers.current = users;
    // im.GetContact({ isfriend: 1 })
    //     .then((res) => {
    //         if (res.users && res.users.length > 0) {
    //             const users = res.users.filter(
    //                 (v) => (v.status !== "deleted" && !isSystemAcc(v.uid) && v.uid !== uid)
    //             );
    // setAllUsers(users as any);
    setSection(userListByLetter([...users]));
    // } else {
    //     setSection([]);
    // }
    // });
  }, []);

  useEffect(() => {
    if ((allUsers?.current?.length ?? 0) > 0) {
      const resultUsers =
        allUsers?.current?.filter((u) => {
          if (search) {
            const searchStr = String(search).toLowerCase();
            const fields = [
              u.name,
              u.remark,
              u.remarkPY,
              u.remarkPYS,
              u.nick,
              u.nickPY,
              u.nickPYS,
              u.namePY,
              u.namePYS,
            ];
            if (!fields.some(v => typeof v === "string" && v.toLowerCase().indexOf(searchStr) !== -1)) {
              return false;
            }
          }
          if (bappkey) {
            const ak = u.appkey ?? '';
            if (ak.startsWith('B') && ak !== bappkey) {
              return false;
            }
          }
          return true;
        }) || [];
      setSection(userListByLetter(resultUsers));
    }
  }, [search, bappkey]);

  const confirmContact = () => {
    if (selectContact.length === 0 || isLoading) {
      return;
    }
    createNewChat();
  };

  // 创建新的会话
  function createNewChat() {
    setIsLoading(true); // 开始加载
    const uids = selectContact.map((v) => v.uid);
    if (from === "Forward") {
      createChat(uids, (topic) => {
        setIsLoading(false); // 结束加载
        navigation.navigate("ForwardChat", {
          selectContact: [topic],
          msg: msg,
        });
      });
    } else {
      createChat(uids, (topic) => {
        // 添加延迟，确保会话信息加载完成
        setTimeout(() => {
          setIsLoading(false); // 结束加载
          toChatView(topic);
          // 创建成功后关闭当前页面
          navigation.goBack();
        }, 1000); // 延迟1秒
      }, true);
    }
  }

  const handleItemClick = (item: User) => {
    const list = [...selectContact];
    if (selectUids.has(item.uid)) {
      selectUids.delete(item.uid);
      const idx = selectContact.findIndex((v) => v.uid === item.uid);
      idx >= 0 && list.splice(idx, 1);
    } else {
      selectUids.add(item.uid);
      list.push(item);
      // 新添加了，检查下新加入的是不是B端用户，如果是的话，把当前所有其它非该公司B的用户去掉
      if ((item.appkey ?? '').startsWith('B')) {
        setBAppkey(item.appkey ?? '');
      }
    }

    const hasB = list.findIndex((v) => (v.appkey ?? '').startsWith('B'));
    if (hasB >= 0) {
      if (bappkey !== list[hasB].appkey) {
        setBAppkey(list[hasB].appkey ?? '');
      }
    } else {
      if (bappkey !== "") {
        setBAppkey("");
      }
    }

    setSelectUids(selectUids);
    setSelectContact(list);
  };

  const renderContactItem = ({ item }: any) => {
    const left = getAvatarByItem(item);
    return (
      <CListItem
        hasRadio={true}
        id={item.uid}
        left={left ?? []}
        isChecked={selectUids.has(item.uid)}
        center={
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{ fontSize: 16, color: color_333333 }}
          >
            {getUserName(item)}
          </Text>
        }
        onClick={() => handleItemClick(item)}
      />
    );
  };

  return (
    <ScreenCancelModal
      onRightPress={confirmContact}
      leftText={Str_Cancel}
      rightText={selectContact.length > 0
        ? `${Str_Confirm}(${selectContact.length})`
        : Str_Confirm}
      rightDisabled={isLoading || selectContact.length === 0}
      rightLoading={isLoading}
      onLeftPress={navigation.goBack}
      title={Str_CreateNewSession} >

      <CSearchInput
        searchVal={search}
        onChange={setSearch}
        placeholder={Str_Search}
      />
      {selectContact.length > 0 && (
        <View style={{ height: 65 }}>
          <ScrollView
            horizontal={true}
            style={styles.selectIconWrap}
            contentContainerStyle={styles.selectContent}
          >
            {selectContact.map((item, index) => {
              return (
                <Pressable
                  key={index.toString()}
                  onPress={() => {
                    handleItemClick(item);
                  }}
                >
                  <View key={item.uid}>
                    <LeftView left={getAvatarByItem(item) ?? []} />
                  </View>
                </Pressable>
              );
            })}
          </ScrollView>
        </View>
      )}
      <View style={{ flex: 1 }}>
        <SectionList
          ref={sectionRef}
          sections={section}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          keyExtractor={(item: UserSchema, rowIndex: number) =>
            item.uid != null ? String(item.uid) : `user-${rowIndex}`
          }
          renderItem={renderContactItem}
          renderSectionHeader={({ section: { title } }) => (
            <View
              style={{
                height: 40,
                justifyContent: "center",
                backgroundColor: color_EEF3FA,
              }}
            >
              <Text style={styles.sectionTitle}>{title}</Text>
            </View>
          )}
          getItemLayout={getItemLayout({
            getItemHeight: 64,
            getSectionHeaderHeight: 40,
          })}
          ListEmptyComponent={<ListEmpty />}
        />
        <Letter
          section={section}
          scrollToLocation={(index) => {
            sectionRef.current?.scrollToLocation({
              animated: true,
              itemIndex: 0,
              sectionIndex: index,
            });
          }}
        />
      </View>
    </ScreenCancelModal>
  );
}

const styles = StyleSheet.create({
  selectIconWrap: {
    backgroundColor: white,
    display: "flex",
    flexDirection: "row",
    padding: 4,
    marginBottom: 5,
  },
  selectContent: {
    justifyContent: "center",
    alignItems: "center",
  },
  sectionTitle: {
    color: color_666666,
    marginLeft: 20,
  },
});
